export const quotationData = {
  bannerData:{
    title:'要求报价',
    desc:'',
    image:require("@/assets/images/single/quotation-banner.jpg")
  }
}